/* eslint-disable @typescript-eslint/no-unused-vars */
import API from "./apiHelpers";
import { routes } from "../Constants/api";
import Pusher from "pusher-js";

class PusherChat {
    private pusher: Pusher;
    public EVENT_MESSAGE: string
    public EVENT_TYPING: string
	public EVENT_NOTIFICATION: string

	constructor() {
		this.EVENT_MESSAGE = "MESSAGE";
		this.EVENT_TYPING = "TYPING";
		this.EVENT_NOTIFICATION = "NOTIFICATION";
		const cluster = process.env.REACT_APP_PUSHER_CLUSTER;
		const pusherKey = process.env.REACT_APP_PUSHER_KEY;
		const authEndpoint = `${API.url}${routes.pusher}`;
		this.pusher = new Pusher(pusherKey, {cluster, authEndpoint});
    }

    public subscribeChannel = chatId => {
    	return this.pusher.subscribe(`private-${chatId}`);
    }

	public unsubscribeChannel = chatId => {
    	return this.pusher.unsubscribe(`private-${chatId}`);
	}

	public getChannel = chatId => {
    	return this.pusher.channel(`private-${chatId}`);
	}

    public getAllChannels = () => {
    	return this.pusher.allChannels();
    }
}

export default new PusherChat();
